// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-item[data-v-73881e45]:hover{background-color:#d3d3d3}", "",{"version":3,"sources":["webpack://./resources/js/components/ExperienceMatrix.vue"],"names":[],"mappings":"AACA,iCACI,wBAAJ","sourcesContent":["\n.nav-item:hover {\n    background-color: lightgray;\n}\n/*\nth,td {\n    border-color: grey !important;\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
